import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#1E3A5F', light: '#2E75B6', dark: '#142840', contrastText: '#ffffff' },
    secondary: { main: '#4472C4', light: '#6B8FD6', dark: '#2F5099', contrastText: '#ffffff' },
    success: { main: '#2E7D32', light: '#4CAF50', dark: '#1B5E20' },
    warning: { main: '#E65100', light: '#FF9800', dark: '#BF360C' },
    error: { main: '#C62828', light: '#EF5350', dark: '#8E0000' },
    info: { main: '#0277BD', light: '#29B6F6', dark: '#01579B' },
    background: { default: '#F4F7FB', paper: '#FFFFFF' },
    text: { primary: '#1A1A2E', secondary: '#5A6478' },
    divider: '#E0E8F0',
  },
  typography: {
    fontFamily: '"Plus Jakarta Sans", "Segoe UI", sans-serif',
    h1: { fontWeight: 800, letterSpacing: '-0.02em' },
    h2: { fontWeight: 700, letterSpacing: '-0.01em' },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: { fontWeight: 600, textTransform: 'none', letterSpacing: '0.01em' },
    subtitle1: { fontWeight: 500 },
    subtitle2: { fontWeight: 600, color: '#5A6478' },
  },
  shape: { borderRadius: 12 },
  shadows: [
    'none',
    '0px 1px 3px rgba(30,58,95,0.08)',
    '0px 2px 6px rgba(30,58,95,0.10)',
    '0px 4px 12px rgba(30,58,95,0.12)',
    '0px 6px 16px rgba(30,58,95,0.14)',
    '0px 8px 24px rgba(30,58,95,0.16)',
    ...Array(19).fill('0px 8px 24px rgba(30,58,95,0.16)'),
  ],
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 8, padding: '8px 20px', fontWeight: 600 },
        containedPrimary: {
          background: 'linear-gradient(135deg, #1E3A5F 0%, #2E75B6 100%)',
          boxShadow: '0 4px 12px rgba(30,58,95,0.3)',
          '&:hover': { boxShadow: '0 6px 16px rgba(30,58,95,0.4)' },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0px 2px 8px rgba(30,58,95,0.08)',
          border: '1px solid #E0E8F0',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 600, borderRadius: 8 },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: { '& .MuiTableCell-head': { backgroundColor: '#F4F7FB', fontWeight: 700, color: '#1E3A5F' } },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: { borderRadius: 6, height: 8 },
      },
    },
    MuiTextField: {
      defaultProps: { size: 'small' },
      styleOverrides: {
        root: { '& .MuiOutlinedInput-root': { borderRadius: 8 } },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: { background: '#1E3A5F', color: '#ffffff' },
      },
    },
  },
});

export default theme;
